(() => {
  "use strict";
  function t(t) {
    return (
      (function (t) {
        if (Array.isArray(t)) return i(t);
      })(t) ||
      (function (t) {
        if (
          ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
          null != t["@@iterator"]
        )
          return Array.from(t);
      })(t) ||
      (function (t, n) {
        if (!t) return;
        if ("string" == typeof t) return i(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === e && t.constructor && (e = t.constructor.name);
        if ("Map" === e || "Set" === e) return Array.from(t);
        if (
          "Arguments" === e ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)
        )
          return i(t, n);
      })(t) ||
      (function () {
        throw new TypeError(
          "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      })()
    );
  }
  function i(t, i) {
    (null == i || i > t.length) && (i = t.length);
    for (var n = 0, e = new Array(i); n < i; n++) e[n] = t[n];
    return e;
  }
  var n = function () {
    return {
      urlParams: "",
      selectedVariant: null,
      firstAvailableVariant: null,
      currentProduct: null,
      optionRadios: [],
      variants: [],
      selected: null,
      qty: 1,
      inventoryQuantity: 0,
      variantAvailableQuantities: [],
      unavailableVariants: [],
      productOption1: null,
      productOption2: null,
      productOption3: null,
      optionIndex1: 0,
      optionIndex2: 0,
      optionIndex3: 0,
      radioOptions1: [],
      radioOptions2: [],
      radioOptions3: [],
      selectedVariantFeaturedMediaId: "",
      isModalForm: !1,
      showStickyButton: !1,
      sellingPlanId: null,
      selectedVariantSaleAllocationPrice: null,
      selectedPlan: "subsave",
      hasSellingPlan: !1,
      selectedPacks: [],
      variantsBadges: [],
      selectedBadgesValues: [],
      init: function () {
        var t = this,
          i = document.querySelector("[data-form-container]"),
          n = document.querySelector(".custom-recharge-widget__wrapper");
        if (n) {
          var e = n.getAttribute("data-selling-plan-id");
          e && (this.sellingPlanId = e);
        }
        if (
          ((this.urlParams = new URL(window.location.href)),
          document.querySelector("[data-current-product]"))
        ) {
          var o = document.querySelector("[data-current-product]").innerHTML;
          (this.currentProduct = JSON.parse(o).currentProduct),
            (this.firstAvailableVariant = JSON.parse(o).firstAvailableVariant);
        }
        if (document.querySelector("[data-badges]")) {
          var a = document.querySelector("[data-badges]").innerHTML;
          this.variantsBadges = JSON.parse(a).variantBadges;
        }
        if (document.querySelector("[data-variants]")) {
          var r = document.querySelector("[data-variants]").innerHTML;
          (this.variants = JSON.parse(r).variants),
            (this.variantAvailableQuantities = JSON.parse(r).inventoryQuantity),
            this.variants &&
              ((this.productOption1 = this.currentProduct.options[0]),
              (this.productOption2 = this.currentProduct.options[1]),
              (this.productOption3 = this.currentProduct.options[2]),
              (this.optionIndex1 = this.currentProduct.options.indexOf(
                this.productOption1
              )),
              (this.optionIndex2 = this.currentProduct.options.indexOf(
                this.productOption2
              )),
              (this.optionIndex3 = this.currentProduct.options.indexOf(
                this.productOption3
              )),
              (this.radioOptions1 = document.querySelectorAll(
                'input[type="radio"][name="'.concat(this.productOption1, '"]')
              )),
              (this.radioOptions2 = document.querySelectorAll(
                'input[type="radio"][name="'.concat(this.productOption2, '"]')
              )),
              (this.radioOptions3 = document.querySelectorAll(
                'input[type="radio"][name="'.concat(this.productOption3, '"]')
              ))),
            this.getSelectedVariant(),
            (this.showStickyButton = !this.isElementInViewport(i));
        }
        window.addEventListener("scroll", function (n) {
          i && (t.showStickyButton = !t.isElementInViewport(i));
        });
      },
      isElementInViewport: function (t) {
        var i = t.getBoundingClientRect();
        return (
          i.top + t.clientHeight >= 0 &&
          i.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)
        );
      },
      getSelectedVariant: function (i) {
        var n = this;
        if (
          ((this.qty = 1),
          (this.optionRadios = t(
            document.querySelectorAll(".product-option__radio")
          )),
          this.optionRadios.forEach(function (t) {
            t.disabled = !1;
          }),
          (this.isModalForm = document.querySelector("[data-modal-form]")),
          this.optionRadios && this.variants)
        ) {
          if (
            ((this.selectedVariant = this.variants.filter(function (t) {
              return (
                t.title ===
                n.optionRadios
                  .filter(function (t) {
                    return t.checked;
                  })
                  .map(function (t) {
                    return t.value;
                  })
                  .join(" / ")
              );
            })[0]),
            this.hideInvalidVariants(),
            !this.selectedVariant)
          ) {
            var e = t(
              document.querySelectorAll(".product-option__radio:checked")
            ).map(function (t) {
              return t.value;
            });
            this.selectedVariant = this.variants.filter(function (t) {
              return t.options[0] === e[0] && t.options[1] === e[1];
            })[0];
            var o = this.selectedVariant.option3;
            this.optionRadios.filter(function (t) {
              return t.value === o;
            })[0].checked = !0;
          }
          this.isModalForm ||
            (this.urlParams.searchParams.set(
              "variant",
              this.selectedVariant.id
            ),
            history.pushState(
              this.selectedVariant.id,
              "variant",
              this.urlParams
            )),
            (this.inventoryQuantity = parseInt(
              this.variantAvailableQuantities.find(function (t) {
                return t[n.selectedVariant.id];
              })[this.selectedVariant.id]
            )),
            this.setVariantAvailable(i),
            (this.selectedVariantFeaturedMediaId = this.selectedVariant
              .featured_media
              ? this.selectedVariant.featured_media.id
              : "");
        } else
          (this.selectedVariant = this.firstAvailableVariant),
            (this.inventoryQuantity = JSON.parse(
              document.querySelector("[data-variants]").innerHTML
            ).inventoryQuantity);
        this.selectedVariant.selling_plan_allocations &&
        this.selectedVariant.selling_plan_allocations.find(function (t) {
          return t.selling_plan_id == n.sellingPlanId;
        })
          ? ((this.selectedVariantSaleAllocationPrice =
              this.selectedVariant.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id == n.sellingPlanId;
              }).price),
            (this.hasSellingPlan = !0))
          : ((this.selectedVariantSaleAllocationPrice =
              this.selectedVariant.price),
            (this.hasSellingPlan = !1)),
          this.updateSelectedVariantPacks();
      },
      hideInvalidVariants: function () {
        var i = this;
        this.optionRadios = t(
          document.querySelectorAll(".product-option__radio")
        );
        var n = t(
          document.querySelectorAll(".product-option__radio:checked")
        ).map(function (t) {
          return t.value;
        });
        this.optionRadios.forEach(function (t) {
          (t.parentNode.style.display = "none"),
            t.parentNode.classList.remove("active-option");
        }),
     
          this.variants.forEach(function (t) {
            i.radioOptions1.forEach(function (n) {
              t.options[i.optionIndex1] === n.value &&
                (n.parentNode.removeAttribute("style"),
                n.parentNode.classList.add("active-option"));
            }),
              i.radioOptions2 &&
                i.radioOptions2.length > 0 &&
                n[0] == t.options[0] &&
                i.radioOptions2.forEach(function (n) {
                  t.options[i.optionIndex2] === n.value &&
                    (n.parentNode.removeAttribute("style"),
                    n.parentNode.classList.add("active-option"));
                }),
              i.radioOptions3 &&
                i.radioOptions3.length > 0 &&
                i.radioOptions3.forEach(function (e) {
                  if (
                    t.options[i.optionIndex3] === e.value &&
                    n[0] == t.options[0] &&
                    n[1] == t.options[1] &&
                    !isHidden(t) 
                  )
                    return (
                      e.parentNode.removeAttribute("style"),
                      e.parentNode.classList.add("active-option"),
                      !0
                    );
                });
          });
      },
      setVariantAvailable: function (t) {
        var i = this;
        this.variants.forEach(function (t) {
          t.options[i.optionIndex1], i.selectedVariant.options[i.optionIndex1];
        }),
          !this.productOption2 &&
            this.productOption1 &&
            this.variants.forEach(function (t) {
              t.available ||
                i.radioOptions1.forEach(function (n) {
                  t.options[i.optionIndex1] === n.value && (n.disabled = !0);
                });
            }),
          this.productOption1 &&
            this.productOption2 &&
            !this.productOption3 &&
            this.variants.forEach(function (t) {
              t.options[i.optionIndex1] ===
                i.selectedVariant.options[i.optionIndex1] &&
                (t.available
                  ? i.radioOptions2.forEach(function (n) {
                      n.value === t.options[i.optionIndex2] &&
                        (n.disabled = !1);
                    })
                  : i.radioOptions2.forEach(function (n) {
                      n.value === t.options[i.optionIndex2] &&
                        (n.disabled = !0);
                    }));
            }),
          this.selectedVariant.available &&
            !t &&
            this.productOption3 &&
            ((this.unavailableVariants = this.variants
              .filter(function (t) {
                return (
                  t.options[i.optionIndex1] ===
                    i.selectedVariant.options[i.optionIndex1] &&
                  t.options[i.optionIndex3] ===
                    i.selectedVariant.options[i.optionIndex3]
                );
              })
              .filter(function (t) {
                return !t.available;
              })),
            this.unavailableVariants.forEach(function (t) {
              i.radioOptions2.forEach(function (n) {
                n.value === t.options[i.optionIndex2] && (n.disabled = !0);
              }),
                i.radioOptions3.forEach(function (n) {
                  n.value === t.options[i.optionIndex3] &&
                    i.selectedVariant.options[i.optionIndex3] !==
                      t.options[i.optionIndex3] &&
                    (n.disabled = !0);
                });
            })),
          this.selectedVariant.available ||
            t ||
            !this.productOption3 ||
            ((this.unavailableVariants = this.variants
              .filter(function (t) {
                return (
                  t.options[i.optionIndex1] ===
                  i.selectedVariant.options[i.optionIndex1]
                );
              })
              .filter(function (t) {
                return !t.available;
              })),
            this.unavailableVariants.forEach(function (t) {
              i.radioOptions2.forEach(function (t) {
                t.value === i.selectedVariant.options[i.optionIndex2] &&
                  (t.disabled = !0);
              }),
                i.radioOptions3.forEach(function (t) {
                  t.value === i.selectedVariant.options[i.optionIndex3] &&
                    (t.disabled = !0);
                });
            })),
          t &&
            (t.target.name === this.productOption1 &&
              ((this.unavailableVariants = this.variants
                .filter(function (t) {
                  return (
                    t.options[i.optionIndex2] ===
                      i.selectedVariant.options[i.optionIndex2] &&
                    t.options[i.optionIndex1] ===
                      i.selectedVariant.options[i.optionIndex1]
                  );
                })
                .filter(function (t) {
                  return !t.available;
                })),
              this.unavailableVariants.forEach(function (t) {
                i.radioOptions2.forEach(function (n) {
                  t.options[i.optionIndex2] === n.value && (n.disabled = !0);
                });
              }),
              this.unavailableVariants.forEach(function (t) {
                i.radioOptions3.forEach(function (n) {
                  t.options[i.optionIndex3] === n.value && (n.disabled = !0);
                });
              })),
            t.target.name === this.productOption2 &&
              ((this.unavailableVariants = this.variants
                .filter(function (t) {
                  return (
                    t.options[i.optionIndex2] ===
                      i.selectedVariant.options[i.optionIndex2] &&
                    t.options[i.optionIndex1] ===
                      i.selectedVariant.options[i.optionIndex1]
                  );
                })
                .filter(function (t) {
                  return !t.available;
                })),
              this.unavailableVariants.forEach(function (t) {
                i.radioOptions3.forEach(function (n) {
                  t.options[i.optionIndex3] === n.value && (n.disabled = !0);
                });
              })),
            t.target.name === this.productOption3 &&
              ((this.unavailableVariants = this.variants
                .filter(function (t) {
                  return (
                    t.options[i.optionIndex3] ===
                      i.selectedVariant.options[i.optionIndex3] &&
                    t.options[i.optionIndex1] ===
                      i.selectedVariant.options[i.optionIndex1]
                  );
                })
                .filter(function (t) {
                  return !t.available;
                })),
              this.unavailableVariants.forEach(function (t) {
                i.radioOptions2.forEach(function (n) {
                  t.options[i.optionIndex2] === n.value && (n.disabled = !0);
                });
              })));
      },
      incrementQty: function () {
        Alpine.store("cart").qty++;
      },
      decrementQty: function () {
        Alpine.store("cart").qty > 1 && Alpine.store("cart").qty--;
      },
      toggleAccordionVideo: function (t) {
        var i = t.target
          .closest(".media-wrapper")
          .querySelector(".accordion__video");
        i.paused
          ? (i.play(), (t.target.innerText = "Pause"))
          : (i.pause(), (t.target.innerText = "Play"));
      },
      changeSellingPlan: function (t) {
        var i = this;
        (this.sellingPlanId = t.target.value),
          this.selectedVariant.selling_plan_allocations.find(function (t) {
            return t.selling_plan_id == i.sellingPlanId;
          }) &&
            (this.selectedVariantSaleAllocationPrice =
              this.selectedVariant.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id == i.sellingPlanId;
              }).price);
      },
      switchSubscription: function (t) {
        this.selectedPlan = t.target.value;
      },
      updateSelectedVariantPacks: function () {
        var t = this,
          i = document.querySelectorAll(".active-option .packs-images"),
          n = document.querySelectorAll(".product-option__pack");
        this.variants &&
          ((this.selectedPacks = this.variants.filter(function (i) {
            if (t.currentProduct.options.length > 2) {
              if (
                i.options[0] &&
                i.options[1] &&
                i.options[0] === t.selectedVariant.options[0] &&
                i.options[1] === t.selectedVariant.options[1]
              )
                return i;
              if (
                i.options[0] &&
                !i.options[1] &&
                i.options[0] === t.selectedVariant.options[0]
              )
                return i;
              if (
                !i.options[0] &&
                i.options[1] &&
                i.options[1] === t.selectedVariant.options[1]
              )
                return i;
            } else if (i.options[0]) return i;
          })),
          console.log("packsImages", i),
          console.log("this.selectedPacks", this.selectedPacks),
          this.selectedPacks &&
            this.selectedPacks.forEach(function (i, e) {
              document.querySelectorAll(".active-option .packs-images")[e] &&
              i.featured_image
                ? ((document.querySelectorAll(".active-option .packs-images")[
                    e
                  ].style.display = "block"),
                  document
                    .querySelectorAll(".active-option .packs-images")
                    [e].setAttribute("src", i.featured_image.src))
                : document.querySelectorAll(".active-option .packs-images")[
                    e
                  ] &&
                  (document.querySelectorAll(".active-option .packs-images")[
                    e
                  ].style.display = "none"),
                t.variantsBadges.forEach(function (t) {
                  t[i.id] &&
                    n[e].querySelector(".variant-value") &&
                    (n[e].querySelector(".variant-value").innerHTML = t[i.id]);
                });
            }));
      },
    };
  };
  document.addEventListener("alpine:init", function () {
    Alpine.data("main_product", n);
  });
})();
